<template>
    <div class="card">
        <div class="card-image">
          <figure class="image is-16by9">
              <img :src="article.image_url" :alt="article.name">
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
              <div class="media-content">
                <p class="title is-6">{{article.name}}</p>
                <p class="subtitle is-6">{{article.author}} <span v-if="article.author">@</span>  {{article.credit}}</p>
              </div>
          </div>
        </div>
        <footer class="card-footer">
            <a @click.prevent="toggleArticle(article.id)" class="card-footer-item" v-if="!article.visible">Show</a>
            <a @click.prevent="toggleArticle(article.id)" class="card-footer-item has-text-danger" v-else>Hide</a>
            <router-link class="card-footer-item" :to="`/articles/${article.id}`">View</router-link>
        </footer>
    </div>
</template>

<script>
import { TOGGLE_ARTICLE } from "@/store/actions";
import { SET_ARTICLE_VISIBLE } from "@/store/mutations";

export default {
  name: "article-card",
  props: ["article"],
  methods: {
    /**
     * Toggles the article visible state
     */
    toggleArticle(articleId) {
      this.$store.dispatch(TOGGLE_ARTICLE, articleId).then(res => {
        if (res.status === 204) {
          this.$store.commit(SET_ARTICLE_VISIBLE, articleId);
        }
      });
    }
  }
};
</script>
